import script from "./ProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductModal.vue?vue&type=style&index=0&id=e9b59af4&lang=scss"

const __exports__ = script;

export default __exports__